/**
 * 同步状态 (Zustand)
 * - online / offline / syncing 状态
 * - 队列大小
 * - 上次同步时间
 */

import { create } from 'zustand';
import type { SyncState } from './socket';

interface SyncStoreState {
  socketState: SyncState;
  queueSize: number;
  lastSyncedAt: number | null;
  setSocketState: (s: SyncState) => void;
  setQueueSize: (n: number) => void;
  markSynced: () => void;
}

export const useSyncStore = create<SyncStoreState>((set) => ({
  socketState: 'idle',
  queueSize: 0,
  lastSyncedAt: null,
  setSocketState: (socketState) => set({ socketState }),
  setQueueSize: (queueSize) => set({ queueSize }),
  markSynced: () => set({ lastSyncedAt: Date.now() }),
}));